<template>
    <div class="row">
        <div class="col-12">
            <div class="container-centered-s">
                <form @submit.prevent="onSubmit" class="mt-2">
                    <form-errors :errors="formErrors"/>

                    <div class="form-row">
                        <div class="col">
                            <form-input v-model="formData.school_district_choice_idx" :errors="errors.school_district_choice_idx" type="radio" :options="schoolDistrictChoiceOptions" label="Please select the school district in which you live."/>
                        </div>
                    </div>

                    <alert-box type="caution">
                    {{ schoolDistrictDisclaimer }}
                    </alert-box>

                    <portal to="address-edit-modal-footer">
                        <button-row stacked>
                            <button type="button" @click.prevent="onPrev()" class="btn btn-outline-primary">Back</button>
                            <button type="button" @click.prevent="onSubmit()" class="btn btn-primary">Continue</button>
                        </button-row>
                    </portal>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ButtonRow from '@/components/ButtonRow'
import api from '@/api'

export default {
    mixins: [FormMixin],
    components: {ButtonRow, },
    props: ['employee', 'employeeUpdate', 'prev'],
    watch: {
        employee() {
            this.reset()
        },
        employeeUpdate() {
            this.reset()
        }
    },
    computed: {
        schoolDistrictChoiceOptions() {
            const result = []
            this.employeeUpdate.geocode_data['school_district_choices']['school_district_choices'].forEach((c, idx) => {
                result.push({text: c['SchoolDistName'].toUpperCase(), value: idx})
            })
            return result
        },
        schoolDistrictDisclaimer() {
            let state = this.employeeUpdate.geocode_data['state']
            return this.schoolDistrictDisclaimers[state] || this.schoolDistrictDisclaimers['default']
        }
    },
    data() {
        const data = {
            formData: this.makeFormData(),
            formRules: {
                'school_district_choice_idx': {
                    presence: {
                        allowEmpty: false,
                        message: "is required"
                    },
                }
            },
            formLabels: {
                'school_district_choice_idx': 'School District Selection',
            },
            schoolDistrictDisclaimers: {
                'default': 'This selection may affect your taxes. If you have questions regarding your school district, please verify with a trusted resource, such as a state or local government office.',
                'OH': 'This selection may affect your taxes. If you have questions regarding your school district, please verify with your County Auditor or contact the Department of Taxation.'
            }
        }
        return data
    },
    methods: {
        makeFormData() {
            let formData = {
                action: 'choose-school-district',
                school_district_choice_idx: this.employeeUpdate.school_district_choice_idx,
            }
            return formData
        },
        onSubmit() {
            if (!this.validate()) {
                return
            }

            this.$store.dispatch('START_LOADING')
            api.patch(`/me/ess/companies/${this.employee.company_id}/updates/${this.employeeUpdate.id}`, this.getFormData()).then((resp) => {
                this.$emit('patch', resp)
                this.$emit('next')
                this.$store.dispatch('STOP_LOADING')
            }).catch((errors) => {
                this.errors = errors
                this.formErrors = errors.__all__
                this.onError()
                this.$store.dispatch('STOP_LOADING')
            })
        },
        onPrev() {
            this.$emit('prev')
        },
    }
}
</script>
